import {
  Box,
  IconButton,
  Popover,
  PopoverTrigger,
  Portal,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  FilterIcon,
} from '@frontend/legacy-components';

const MobileFiltersPopover = ({ children }) => (
  <Box
    bg="page.surface"
    position="absolute"
    right="0"
    top="0"
    display={{ base: 'flex', tablet: 'none' }}
    height={6}
    width={6}
    border="1px solid"
    borderColor="separator.divider"
    zIndex={1000}
  >
    <Popover placement="bottom-end" size="sm">
      <PopoverTrigger>
        <Box as="button" margin="auto">
          <IconButton height={6} width={6}>
            <FilterIcon size={4} color="feature.secondary" />
          </IconButton>
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverHeader>Filters</PopoverHeader>
          <PopoverBody maxHeight="60vh" overflow="scroll">
            {children}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  </Box>
);

export default MobileFiltersPopover;
